import { UrlsConfig } from "configs/urlsConfig";
import { I18nLocale } from "constants/enum";
import { removeLeadingSlash } from "utils/removeLeadingSlash";

import localizedPathnames from "./localized-pathnames.json";

const findNextJSPath = (rawPath: string) =>
    Object.keys(localizedPathnames).find(
        (nextJSPathKey) => nextJSPathKey === rawPath
    );

const findNextJSPathWithVariable = (rawPath: string) =>
    Object.keys(localizedPathnames).find(
        (nextJSPathKey) =>
            nextJSPathKey.startsWith(rawPath) && nextJSPathKey.indexOf("/") >= 0
    );

export const getLocalizedPathname = (
    pathname: string,
    locale: I18nLocale,
    // If passed true method will return UrlsConfig entry path if no localized path is specified in localizedPathnames
    returnNonLocalized = false
) => {
    const secondSlashIndex = pathname.lastIndexOf("/");
    const complexPath = secondSlashIndex > 0;

    if (complexPath) {
        const fullMatchNextJSPath = findNextJSPath(
            removeLeadingSlash(pathname)
        );
        if (fullMatchNextJSPath) {
            const dictionaryEntry = (localizedPathnames as any)?.[
                fullMatchNextJSPath
            ];
            return dictionaryEntry ? `/${dictionaryEntry[locale]}` : undefined;
        }
        const [pagePath, pageParam] = removeLeadingSlash(pathname).split("/");
        const matchWithVariableNextJSPath =
            findNextJSPathWithVariable(pagePath);

        if (!matchWithVariableNextJSPath) return undefined;

        const dictionaryEntry = (localizedPathnames as any)?.[
            matchWithVariableNextJSPath
        ];
        const localizedPath = dictionaryEntry?.[locale];
        const localizedPathSlashIndex = localizedPath?.indexOf("/");

        return localizedPathSlashIndex >= 0
            ? `/${localizedPath.slice(0, localizedPathSlashIndex)}/${pageParam}`
            : undefined;
    }

    const dictionaryEntry = (localizedPathnames as any)?.[
        removeLeadingSlash(pathname)
    ];

    if (
        returnNonLocalized &&
        !dictionaryEntry?.[locale] &&
        (<any>Object).values(UrlsConfig).includes(pathname as keyof UrlsConfig)
    ) {
        return pathname;
    }

    return dictionaryEntry?.[locale]
        ? `/${dictionaryEntry[locale]}`
        : undefined;
};
